import {html} from 'uhtml';
import {BasePanel} from '../panel';
import {ModomSectionPlugin} from './base-plugin';
import menu00Modom from '../img/modom_icons/00_MENU/00_modom.svg';
import menu01Layout from '../img/modom_icons/00_MENU/01_layout.svg';
import menu02Forma from '../img/modom_icons/00_MENU/02_forma.svg';
import menu03Dimensione from '../img/modom_icons/00_MENU/03_dimensione.svg';
import menu04Loggia from '../img/modom_icons/00_MENU/04_loggia.svg';
import menu05Infissi from '../img/modom_icons/00_MENU/05_infissi.svg';
import menu06Esterni from '../img/modom_icons/00_MENU/06_esterni.svg';
import menu07Interni from '../img/modom_icons/00_MENU/07_interni.svg';
import menu08Impianti from '../img/modom_icons/00_MENU/08_impianti.svg';
import menu09Optional from '../img/modom_icons/00_MENU/09_optional.svg';

class ModomPanel extends BasePanel {
    initialize() {
        super.initialize();
        this.container.style.height = '650px';
        this.container.style.resize = 'both';
        const panelOuterContainer = this.container.children[2];
        panelOuterContainer.classList.add('scrolling-container');
    }
}

class ModomPlugin extends ModomSectionPlugin {
    PanelClass = ModomPanel;

    name = 'modomPanel';

    label = '0.Configuratore MODOM';

    icon = menu00Modom;

    getTemplate() {
        return html`
            <div class="panel-container">
                <div class="label movableArea">
                    MODOM sviluppa architetture modulari di design.
                    <br />
                    <br />
                    L’approccio progettuale pone molta attenzione alla qualità dei materiali selezionati ed ogni soluzione si adatta perfettamente nell'ambiente in cui verrà installata.
                    <br />
                    <br />
                    Hai trovato il terreno perfetto?
                    <br />
                    <br />
                    Per garantire un progetto di successo, abbiamo la necessità di conoscere il luogo nel quale pensi di realizzare il tuo edificio, al fine di calibrare al meglio tutte le sue caratteristiche: dalle prestazioni energetiche al rispetto della normativa di sicurezza antisismica.
                    <br />
                    <br />
                    Attraverso questo configuratore, puoi “giocare” a progettare, puoi conoscere meglio il funzionamento del nostro sistema modulare ed immaginare quale sarà il risultato finale.
                    <br />
                    <br />
                    Vuoi un prodotto MODOM dal design unico e pensato in esclusiva per te?
                    <br />
                    <br />
                    Il team di MODOM è in grado di fornire supporto progettuale per trovare le giuste soluzioni adatte a soddisfare ogni tua esigenza.
                    <br />
                    <br />
                    Non ti resta che spiegarci cosa hai in mente!
                    <br />
                    <br />
                    CONTATTACI:
                    <br />
                    <a href="mailto:info@modom.it">info@modom.it</a>
                </div>
            </div>
        `;
    }
}

class LayoutPanel extends BasePanel {
    initialize() {
        super.initialize();
        // Keep icons and labels large enough
        this.container.style.minWidth = '550px';
    }
}

class LayoutPlugin extends ModomSectionPlugin {
    PanelClass = LayoutPanel;

    name = 'modomLayoutPanel';

    label = '1. Layout';

    icon = menu01Layout;

    getTemplate(options) {
        const isSelected = name => options.layout === name;

        const getContainerClasses = name => {
            const isSelectedClass = isSelected(name) ? 'modom-button-selected' : '';
            return `item-container modom-button ${isSelectedClass}`;
        };

        const getItemClasses = (name, isWip) => {
            const icon = `modom-icon modom-icon-${name.toLowerCase()}`;
            const wipIcon = isWip ? 'item-icon-disabled' : '';
            return `item ${icon} ${wipIcon}`;
        };

        const getItem = (name, label, isWip) => {
            const containerClasses = getContainerClasses(name);
            const itemClasses = getItemClasses(name, isWip);
            return html`
                <div class="${containerClasses}">
                    <div class="item-icon-container">
                        <div class="${itemClasses}"></div>
                        ${isWip ? html`
                            <div class="item-icon-text-container">
                                <div class="item-icon-text">
                                    Work in progress
                                </div>
                            </div>
                        ` : ''}
                    </div>
                    <span class="item-label">${label}</span>
                </div>
            `;
        };

        return html`
            <div class="panel-container configuration-panel">
                <div class="label movableArea">
                    Seleziona il layout da configurare.
                </div>
                <div class="selections">
                    ${getItem('lineare', 'Lineare', false)}
                    ${getItem('sfalsata', 'Sfalsata', true)}
                    ${getItem('combinata', 'Combinata', true)}
                    ${getItem('spaziata', 'Spaziata', true)}
                    ${getItem('angolata', 'Angolata', true)}
                </div>
            </div>
        `;
    }
}

class FormaPanel extends BasePanel {
    initialize() {
        super.initialize();

        // Keep icons and labels large enough
        this.container.style.minWidth = '550px';
    }
}

class FormaPlugin extends ModomSectionPlugin {
    PanelClass = FormaPanel;

    name = 'modomFormaPanel';

    label = '2. Forma';

    icon = menu02Forma;

    filterModelData(modelData, options) {
        return modelData
            // Filter configuration
            .filter(({properties}) => {
                const config = properties.Forge_Configuration;
                return config === options.configuration || config === 'GEN';
            });
    }

    getTemplate(options, updateOptions) {
        const isSelected = name => options.configuration === name;

        const setConfigurationAction = name => () => {
            if (!isSelected(name)) {
                return updateOptions({
                    editingType: '',
                    editingWallCode: '',
                    configuration: name
                });
            }
        };

        const getContainerClasses = name => {
            const isSelectedClass = isSelected(name) ? 'modom-button-selected' : '';
            return `item-container modom-button ${isSelectedClass}`;
        };

        const getItemClasses = name => {
            const icon = `modom-icon modom-icon-${name.toLowerCase()}`;
            return `item ${icon}`;
        };

        const getItem = (name, label) => {
            const itemAction = setConfigurationAction(name);
            const containerClasses = getContainerClasses(name);
            const itemClasses = getItemClasses(name);
            return html`
                <div class="${containerClasses}" onclick=${itemAction}>
                    <div class="${itemClasses}"></div>
                    <span class="item-label">${label}</span>
                </div>
            `;
        };

        return html`
            <div class="panel-container configuration-panel">
                <div class="label movableArea">
                    Modom può realizzare tre tipologie di copertura.
                    <br />
                    Scegli tra le varie soluzioni: piana, con falda unica inclinata e a doppia falda con pendenza 35°
                </div>
                <div class="selections">
                    ${getItem('FLR', 'Falda Piana')}
                    ${getItem('SPR', 'Falda Inclinata')}
                    ${getItem('DPR', 'Falda Doppia')}
                </div>
            </div>
        `;
    }
}

class DimensionePlugin extends ModomSectionPlugin {
    name = 'modomDimensionePanel';

    label = '3. Dimensione';

    icon = menu03Dimensione;

    sizeReferenceMap = {
        3: {
            name: 'SHELL15',
            size: '19,20 mq',
            subSize: '(15,65 mq)'
        },
        4: {
            name: 'SHELL20',
            size: '25,10 mq',
            subSize: '(20,90 mq)'
        },
        6: {
            name: 'SHELL31',
            size: '36,90 mq',
            subSize: '(31,40 mq)'
        },
        7: {
            name: 'SHELL36',
            size: '42,75 mq',
            subSize: '(36,60 mq)'
        }
    };

    filterModelData(modelData, options) {
        return modelData
            // Filter length
            .filter(({properties}) => {
                const length = properties.Forge_Length;
                return length <= options.length || length === `${options.length}.BW`;
            });
    }

    getTemplate(options, updateOptions) {
        const getButton = (icon, action) => {
            const classes = `item modom-icon modom-icon-${icon}`;
            return html`
                <div class="item-container modom-button" onclick=${action}>
                    <div class="${classes}"></div>
                </div>
            `;
        };
        const sizeRefNumbers = Object.keys(this.sizeReferenceMap).map(n => Number(n));
        const sizeIndex = sizeRefNumbers.indexOf(options.length);
        const minusAction = () => {
            const lengthIndex = Math.max(sizeIndex - 1, 0);
            const length = sizeRefNumbers[lengthIndex];
            updateOptions({
                editingType: '',
                editingWallCode: '',
                length
            });
        };
        const plusAction = () => {
            const lengthIndex = Math.min(sizeIndex + 1, sizeRefNumbers.length - 1);
            const length = sizeRefNumbers[lengthIndex];
            updateOptions({
                editingType: '',
                editingWallCode: '',
                length
            });
        };
        const modomSizeCard = () => {
            const texts = this.sizeReferenceMap[options.length];
            return html`
                <div class="size-area-name">${texts.name}</div>
                <div class="size-area-size">${texts.size}</div>
                <div class="size-area-subsize">${texts.subSize}</div>
            `;
        };
        return html`
            <div class="panel-container length-panel">
                <div class="label movableArea">
                    Seleziona la dimensione che desideri.
                    <br />
                    <i>* La superficie indicata non include i componenti loggia</i>
                </div>
                <div class="selections">
                    ${getButton('minus', minusAction)}
                    <div class="item-container item-size-area">
                        ${modomSizeCard()}
                    </div>
                    ${getButton('plus', plusAction)}
                </div>
            </div>
        `;
    }
}

class LoggiaPlugin extends ModomSectionPlugin {
    name = 'modomLoggiaPanel';

    label = '4. Loggia';

    icon = menu04Loggia;

    toggleLabel = {
        ON: 'ON',
        OFF: 'OFF'
    };

    filterModelData(modelData, options) {
        return modelData
            // Filter loggia
            .filter(({properties}) => {
                const loggia = properties.Forge_Loggia;
                const frontLoggia = loggia === options.frontLoggia;
                const backLoggia = loggia === options.backLoggia;
                return frontLoggia || backLoggia || loggia === '';
            });
    }

    // TODO: Complete panel
    getTemplate(options, updateOptions) {
        const itemSelect = (prefix, toggleState, isSelected, action) => {
            const getButtonClasses = () => {
                const isSelectedClass = isSelected() ? 'modom-button-selected' : '';
                return `wall-item item-container item-loggia-${prefix} modom-button ${isSelectedClass}`;
            };
            return html`
                <div class="${getButtonClasses()}" onclick=${action}>
                    <div class="item item-loggia-label modom-icon">
                        ${toggleState}
                    </div>
                </div>
            `;
        };

        const toggleLoggiaSelect = (prefix, property, updateProperty) => {
            const loggiaOn = `${prefix}.LG`;
            const loggiaOff = `${prefix}.NL`;
            const loggiaIsActive = property === loggiaOn;
            return itemSelect(
                prefix,
                loggiaIsActive ? this.toggleLabel.ON : this.toggleLabel.OFF,
                () => loggiaIsActive,
                () => updateOptions({[updateProperty]: loggiaIsActive ? loggiaOff : loggiaOn})
            );
        };

        const getWallCode = (code, number) => `${code}${number}`;

        const getEditingAction = (isEditing, options) => (
            () => updateOptions(
                isEditing
                    ? {editingType: '', editingWallCode: ''}
                    : {...options}
            )
        );

        const frontTemplate = () => {
            const isEditing = options.editingType === 'front';
            const action = getEditingAction(
                isEditing,
                {editingType: 'front', editingWallCode: ''}
            );
            return html`
                <div class="surface-item-container surface-item-container-vertical">
                    <div class="surface-item surface-item-empty surface-front surface-front-wall" ?data-editing=${isEditing} onclick=${action}></div>
                    <div class="surface-item surface-front" ?data-editing=${isEditing} onclick=${action}></div>
                </div>
            `;
        };

        const wallsTemplate = (size, number) => {
            const action = (side, code, isEditing) => getEditingAction(
                isEditing,
                {editingType: side, editingWallCode: getWallCode(code, number)}
            );

            const isLeft = options.editingWallCode === getWallCode('L', number);
            const isRight = options.editingWallCode === getWallCode('R', number);

            const leftAction = action('left', 'L', isLeft);
            const rightAction = action('right', 'R', isRight);

            return options.length >= size ? html`
                <div class="surface-item-container surface-item-container-horizontal">
                    <div class="surface-item surface-item-empty surface-wall surface-wall-left" ?data-editing=${isLeft} onclick=${leftAction}></div>
                    <div class="surface-item surface-item-empty surface-wall surface-wall-inner surface-wall-left" ?data-editing=${isLeft} onclick=${leftAction}></div>
                </div>
                <div class="surface-item-container surface-item-container-horizontal">
                    <div class="surface-item surface-item-empty surface-wall surface-wall-inner surface-wall-right" ?data-editing=${isRight} onclick=${rightAction}></div>
                    <div class="surface-item surface-item-empty surface-wall surface-wall-right" ?data-editing=${isRight} onclick=${rightAction}></div>
                </div>
            ` : '';
        };

        const backTemplate = () => {
            const isEditing = options.editingType === 'back';
            const action = getEditingAction(
                isEditing,
                {editingType: 'back', editingWallCode: ''}
            );
            return html`
                <div class="surface-item-container surface-item-container-vertical">
                    <div class="surface-item surface-back" ?data-editing=${isEditing} onclick=${action}></div>
                    <div class="surface-item surface-item-empty surface-back surface-back-wall" ?data-editing=${isEditing} onclick=${action}></div>
                </div>
            `;
        };

        return html`
            <div class="panel-container toggles-panel">
                <div class="label movableArea">
                    Uno spazio coperto all’aperto potrebbe interessarti? Preferisci una schermatura per i raggi solari?
                    <br />
                    Scegli la loggia che preferisci, incrementa il tuo spazio e trasforma il tuo progetto
                    dando un tocco di design in più.
                    <br />
                    <i>* Ogni componente loggia aggiunge una superficie di 6,00mq lordi / 5,00mq netti.</i>
                    <br />
                    <br />
                    <b>NOTA: il fronte si trova in basso</b>
                </div>
                <div class="layout-container">
                    <div class="layout layout-loggia select" data-editing-type="left">

                        <div class="select-surface surface">
                            <div class="surface-base" ?data-editing="left" not-hoverable>
                                ${backTemplate()}

                                ${wallsTemplate(7, 7)}

                                ${wallsTemplate(6, 6)}
                                ${wallsTemplate(6, 5)}

                                ${wallsTemplate(4, 4)}

                                ${wallsTemplate(3, 3)}
                                ${wallsTemplate(3, 2)}
                                ${wallsTemplate(3, 1)}

                                ${frontTemplate()}
                            </div>
                        </div>

                        <div class="select-left select-column">
                            ${toggleLoggiaSelect('BK', options.backLoggia, 'backLoggia')}
                            ${toggleLoggiaSelect('FR', options.frontLoggia, 'frontLoggia')}
                        </div>

                    </div>
                </div>
            </div>
        `;
    }
}

class InfissiPanel extends BasePanel {
    initialize() {
        super.initialize();
        // Keep icons large enough
        this.container.style.minWidth = '320px';
    }
}

class InfissiPlugin extends ModomSectionPlugin {
    PanelClass = InfissiPanel;

    name = 'modomInfissiPanel';

    label = '5. Infissi';

    icon = menu05Infissi;

    filterModelData(modelData, options) {
        return modelData
            // Filter front
            .filter(({properties}) => {
                const front = properties.Forge_Front;
                return front === options.front || front === '';
            })
            // Filter back
            .filter(({properties}) => {
                const back = properties.Forge_Back;
                return back === options.back || back === '';
            })
            // Filter walls
            .filter(({properties}) => {
                const version = properties.Forge_Wall_Version;
                const position = properties.Forge_Wall_Position;
                const isNotWall = version === '' && position === '';
                const selectedWallVersion = options.walls[position];
                return isNotWall || selectedWallVersion === version;
            });
    }

    getTemplate(options, updateOptions) {
        const modelConfig = options.configuration;
        const selectedCode = options.editingWallCode;

        const itemSelect = (icon, isSelected, action) => {
            const getButtonClasses = () => {
                const isSelectedClass = isSelected() ? 'modom-button-selected' : '';
                return `wall-item item-container modom-button ${isSelectedClass}`;
            };
            return html`
                <div class="${getButtonClasses()}" onclick=${action}>
                    <div class="${`item modom-icon modom-icon-${icon}`}"></div>
                </div>
            `;
        };

        const frontSelect = (icon, value) => itemSelect(
            icon,
            () => options.front === value,
            () => updateOptions({front: value})
        );
        const backSelect = (icon, value) => itemSelect(
            icon,
            () => options.back === value,
            () => updateOptions({back: value})
        );
        const wallsSelect = (icon, value) => itemSelect(
            icon,
            () => options.walls[selectedCode] === value,
            () => updateOptions({walls: {[selectedCode]: value}})
        );

        const getWallCode = (code, number) => `${code}${number}`;

        const getEditingAction = (isEditing, options) => (
            () => updateOptions(
                isEditing
                    ? {editingType: '', editingWallCode: ''}
                    : {...options}
            )
        );

        const frontTemplate = () => {
            const isEditing = options.editingType === 'front';
            const action = getEditingAction(
                isEditing,
                {editingType: 'front', editingWallCode: ''}
            );
            return html`
                <div class="surface-item-container surface-item-container-vertical" ?data-editing=${isEditing} onclick=${action}>
                    <div class="surface-item surface-front surface-front-wall"></div>
                    <div class="surface-item surface-item-empty surface-front"></div>
                </div>
            `;
        };

        const wallsTemplate = (size, number) => {
            const action = (side, code, isEditing) => getEditingAction(
                isEditing,
                {editingType: side, editingWallCode: getWallCode(code, number)}
            );

            const isLeft = options.editingWallCode === getWallCode('L', number);
            const isRight = options.editingWallCode === getWallCode('R', number);

            const leftAction = action('left', 'L', isLeft);
            const rightAction = action('right', 'R', isRight);

            return options.length >= size ? html`
                <div class="surface-item-container surface-item-container-horizontal" ?data-editing=${isLeft} onclick=${leftAction}>
                    <div class="surface-item surface-wall surface-wall-left"></div>
                    <div class="surface-item surface-item-empty surface-wall surface-wall-inner surface-wall-left"></div>
                </div>
                <div class="surface-item-container surface-item-container-horizontal" ?data-editing=${isRight} onclick=${rightAction}>
                    <div class="surface-item surface-item-empty surface-wall surface-wall-inner surface-wall-right"></div>
                    <div class="surface-item surface-wall surface-wall-right"></div>
                </div>
            ` : '';
        };

        const backTemplate = () => {
            const isEditing = options.editingType === 'back';
            const action = getEditingAction(
                isEditing,
                {editingType: 'back', editingWallCode: ''}
            );
            return html`
                <div class="surface-item-container surface-item-container-vertical" ?data-editing=${isEditing} onclick=${action}>
                    <div class="surface-item surface-item-empty surface-back"></div>
                    <div class="surface-item surface-back surface-back-wall"></div>
                </div>
            `;
        };

        return html`
            <div class="panel-container toggles-panel">
                <div class="label movableArea">
                    Puoi personalizzare il tuo progetto andando ad inserire gli infissi dove e come preferisci.
                    <br />
                    Seleziona le aree da personalizzare e configura pareti laterali e chiusure su fronte e retro
                    poi scegli il componente da inserire tra quelli a disposizione.
                    <br />
                    <br />
                    <b>NOTA: il fronte si trova in basso</b>
                </div>
                <div class="layout-container">
                    <div class="layout select" data-editing-type=${options.editingType}>

                        <div class="select-surface surface">
                            <div class="surface-base" ?data-editing=${options.editingType !== ''}>
                                ${backTemplate()}

                                ${wallsTemplate(7, 7)}

                                ${wallsTemplate(6, 6)}
                                ${wallsTemplate(6, 5)}

                                ${wallsTemplate(4, 4)}

                                ${wallsTemplate(3, 3)}
                                ${wallsTemplate(3, 2)}
                                ${wallsTemplate(3, 1)}

                                ${frontTemplate()}
                            </div>
                        </div>

                        <div class="select-front select-grid-3">
                            ${frontSelect(`front-${modelConfig}-1`, '1')}
                            ${frontSelect(`front-${modelConfig}-2`, '2')}
                            ${frontSelect(`front-${modelConfig}-3`, '3')}
                            ${frontSelect(`front-${modelConfig}-4`, '4')}
                            ${frontSelect(`front-${modelConfig}-5`, '5')}
                            ${frontSelect(`front-${modelConfig}-6`, '6')}
                        </div>

                        <div class="select-back select-grid-4">
                            ${backSelect(`back-${modelConfig}-1`, '1')}
                            ${backSelect(`back-${modelConfig}-2`, '2')}
                            ${backSelect(`back-${modelConfig}-3`, '3')}
                            ${backSelect(`back-${modelConfig}-4`, '4')}
                            ${backSelect(`back-${modelConfig}-5`, '5')}
                            ${backSelect(`back-${modelConfig}-6`, '6')}
                            ${backSelect(`back-${modelConfig}-7`, '7')}
                            ${backSelect(`back-${modelConfig}-8`, '8')}
                        </div>

                        <div class="select-left select-column">
                            ${wallsSelect('wall-full', '1')}
                            ${wallsSelect('wall-large', '2')}
                            ${wallsSelect('wall-medium', '3')}
                            ${wallsSelect('wall-small', '4')}
                        </div>

                        <div class="select-right select-column">
                            ${wallsSelect('wall-full', '1')}
                            ${wallsSelect('wall-large', '2')}
                            ${wallsSelect('wall-medium', '3')}
                            ${wallsSelect('wall-small', '4')}
                        </div>

                    </div>
                </div>
            </div>
        `;
    }
}

class EsterniPlugin extends ModomSectionPlugin {
    name = 'modomEsterniPanel';

    label = '6. Esterni';

    icon = menu06Esterni;
}

class InterniPlugin extends ModomSectionPlugin {
    name = 'modomInterniPanel';

    label = '6. Interni';

    icon = menu07Interni;
}

class ImpiantiPlugin extends ModomSectionPlugin {
    name = 'modomImpiantiPanel';

    label = '6. Impianti';

    icon = menu08Impianti;
}

class OptionalPlugin extends ModomSectionPlugin {
    name = 'modomOptionalPanel';

    label = '6. Optional';

    icon = menu09Optional;
}

export default [
    ModomPlugin,
    LayoutPlugin,
    FormaPlugin,
    DimensionePlugin,
    LoggiaPlugin,
    InfissiPlugin,
    EsterniPlugin,
    InterniPlugin,
    ImpiantiPlugin,
    OptionalPlugin
];
